// extracted by css-extract-rspack-plugin
export default {"double":"Box__double--CviF7"};